export default {
  en: {
    title: 'Utilities',
    callLink: 'Call link',
    calendarLink: 'Calendar link',
    alertSegment: 'The generated link will trigger a call to the selected segment',
    alertCalendar: 'This QR code is unique and doesn\'t change, so please be careful making changes to your website',
    alertQR: 'This QR code is unique doesn\'t change, so please be careful making changes in your website',
  },
  es: {
    title: 'Utilidades',
    callLink: 'Enlace de llamada',
    calendarLink: 'Enlace de calendario',
    alertSegment: 'El enlace generado desencadenará una llamada al segmento seleccionado',
    alertCalendar: 'El enlace generado abrirá automáticamente el calendario seleccionado',
    alertQR: 'Este código QR es único y no cambia, así que por favor tenga cuidado al realizar cambios en su sitio web',
  },
  fr: {
    title: 'Utilitaires',
    callLink: 'Lien d\'appel',
    calendarLink: 'Lien de calendrier',
    alertSegment: 'Le lien généré déclenchera un appel au segment sélectionné',
    alertCalendar: 'Le lien généré ouvrira automatiquement le calendrier sélectionné',
    alertQR: 'Ce code QR est unique et ne change pas, alors veuillez faire attention lors de la modification de votre site web',
}

}
